import { useState } from "react";
import useTranslations from "../../core/i18n/useTranslations";
import useUser from "../../core/user/useUser";
import { notify } from "../../ui-lib/components/Alerts/Toast";
import { updateGuiConfig } from "../../core/user/token";
import { notifyApiErrors } from "../../core/helpers/helpers";
import { deleteAlternatives } from "../../core/api/alternatives/alternatives";
import PrimeModal from "../../ui-lib/components/PrimeModal/PrimeModal";

export const DeleteAlternativesModal = ({
  alternativeId,
  adminId,
  isOpen,
  onClose,
}: {
  alternativeId?: string | number;
  adminId: string | number;
  isOpen: boolean;
  onClose: () => void;
}) => {
  const t = useTranslations();
  const user = useUser();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const onSubmit = async () => {
    if (!alternativeId) {
      return;
    }
    setIsLoading(true);
    try {
      await deleteAlternatives(alternativeId, user.authenticatedRequest);
      notify({
        message: t("Messages:delete_alternative_success"),
      });
      if (user.accountId === adminId) {
        await updateGuiConfig(user);
      }
      onClose();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <PrimeModal
      withFooter
      withHeader
      header={t("Administrator:delete_alternative")}
      isOpen={isOpen}
      onClose={onClose}
      loading={isLoading}
      fixedWidth="576px"
      submitBtn={{
        text: t("Administrator:remove_alternative"),
        variant: "destructive",
        onClick: onSubmit,
      }}
      cancelBtn={{
        text: t("Common:cancel"),
        variant: "secondary",
        onClick: onClose,
      }}
    >
      <p style={{ color: "var(--Grey-600)" }}>
        {t("Administrator:delete_alternative_confirm")}
      </p>
    </PrimeModal>
  );
};
